// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
// @ts-ignore
import {App_context} from '../context.js';
// @ts-ignore
import {Input} from '../lib/input.js';
import cn from 'classnames';
import {Checkbox} from '../lib/checkbox';
import {useHistory} from 'react-router-dom';
import styles from './uninstall_survey.module.less';
import {perr_www_visit} from 'hola_pub_util';
import {Settings_context} from '../settings_ctx';
import {Button} from '../lib/button';
// @ts-ignore
import {get_exe_link} from '../install_links';
// @ts-ignore
import {download_file} from '../install_util';
// @ts-ignore
import {ga_track_download_send} from '../ga';
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {open_store} from './install_btn';
import {guess} from 'zuser_agent';
import {guess_os_and_version} from '../client_hints_global';
// @ts-ignore
import {get_browser} from 'hola_pub_util';
// @ts-ignore
import cookie from 'cookie';
import {use_translation_v} from '../lib/trans_v';

const reinstall_button_captions = {
    extension: 'Reinstall extension',
    vpn: 'Reinstall Hola',
    browser: 'Reinstall Hola Browser',
};
const arr_rand = (items: any[])=>{
  return [...items].sort(()=>Math.random()>0.5 ? 1 : -1);
};
const vpn_reinstall = (history, os)=>{
    const link = get_exe_link();
    ga_track_download_send(os=='macos' ? 'dmg' : 'exe',
        'vpn_from_survey', link, null, undefined);
    download_file(link);
    history.push('/after_download?s=install');
};
const browser_reinstall = (history, os)=>{
    const link = get_exe_link({hola_browser: true});
    ga_track_download_send(os=='macos' ? 'dmg' : 'exe', 'browser_from_survey',
        link, null, undefined, {hola_browser: true});
    download_file(link);
    history.push('/after_download?s=install&browser=1');
};
const reinstall = (product, history, sys)=>{
    switch (product)
    {
    case 'vpn': return vpn_reinstall(history, sys.os);
    case 'browser': return browser_reinstall(history, sys.os);
    case 'extension': return open_store();
    }
};

type t_product = 'vpn'|'browser'|'extension';
interface i_uninstall_survey_props {
    product: t_product;
    country_code: string;
    no_reinstall?: boolean;
    reinstall_lp?: string;
}

interface i_input_row {
    label: string;
    value: string;
    on_change: (value: string)=>void;
}

const Input_row = ({label, value, on_change}: i_input_row)=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.input_row}>
      <p className={cn(theme.med, styles.input_label)}>{label}</p>
      <Input cl={styles.input} placeholder="optional" value={value}
        on_change={v=>on_change(v)} no_margin={true}/>
    </div>;
};

const Uninstall_survey_hola2023 = (props:i_uninstall_survey_props)=>{
    const {t} = use_translation_v({version: 0});
    const survey_data = t(`surveys.all.uninstall_survey`,
        {returnObjects: true});
    const history = useHistory();
    // @ts-ignore
    const {user} = useContext(App_context);
    const {theme} = useContext(Settings_context);
    const [state, set_state] = useState({} as any);
    const [is_button_active, set_is_button_active] = useState(false);
    const [q1, set_q1] = useState({} as any);
    const [checkboxes_order, set_checkboxes_order] = useState(null);
    const sys = guess();
    let all_questions;
    useEffect(()=>{
        all_questions = survey_data.pages?.[0].questions;
        set_q1(all_questions?.[0]);
        const as_arr_obj = all_questions?.[0].choices
            ?.map((title, id)=>({id, title}));
        set_checkboxes_order(()=>{
            return as_arr_obj ? arr_rand(as_arr_obj) : null;
        });
        perr_www_visit({id: 'www_uninstall_survey_visit', user});
    }, []);
    useEffect(()=>{
        set_is_button_active(checkboxes_order?.some(checkbox=>{
            return state.hasOwnProperty(''+checkbox.id) &&
                state[''+checkbox.id];
        }));
    }, [state]);
    const send = ()=>etask(function*(){
        if (!is_button_active)
        {
            set_state(v=>({...v, error: 'Please select at least one reason'}));
            return;
        }
        const user_id = cookie.get('h_visitor_id');
        const browser = get_browser();
        const os = guess_os_and_version().os;
        const answers = [];
        checkboxes_order.forEach(el=>{
            if (state[el.id])
                answers.push(el.id);
        });
        const text_note = `${state?.explain||''} ${state?.contact||''}`.trim();
        try {
            const info = {
                survey_id: 'uninstall_survey_question1',
                answers: [props.product].concat(answers),
                text_note: text_note,
                user_id,
                country_code: props.country_code,
                browser,
                os,
            };
            yield fetch('/surveys', {method: 'POST', body: info});
            history.push('/survey_result_hola2023');
        } catch(e){ console.log(e); }
    });
    return <div className={cn(styles.survey2023)}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h4 className={cn(theme.bold, styles.title)}>Sorry to see you go</h4>
          <img src={'https://hola.org/cms/wp-content/'+
            'uploads/2023/08/Group-1-1.png'}
            className={cn(styles.title_image, 'lazyload')} alt="group_1"/>
        </div>
        <div className={styles.content}>
          <div className={styles.survey_description}>
            <img alt={`Hola install ${props.product}`}
              className={cn(styles.survey_description_image, 'lazyload')}
              src={'https://hola.org/cms/wp-content/'+
                'uploads/2023/08/latest_emptystate_img.png'}/>
            <p className={styles.description}>
              We use your feedback to understand how we can make our product
              better and more useful. We're committed to improving it, and we
              hope to see you again in the future.
            </p>
            {!props.no_reinstall && <Button color="white"
              caption={reinstall_button_captions[props.product]}
              on_click={()=>reinstall(props.product, history, sys)}/>}
          </div>
          <div className={styles.survey_block}>
            <div className={styles.survey}>
              <h5 className={cn(theme.bold, styles.survey_title)}>
                {q1?.text}
              </h5>
              <div className={styles.survey_questions}>
                {checkboxes_order?.map(el=><Checkbox key={el.id}
                  caption_cls={styles.survey_question} caption={el.title}
                  size="sm" light color="grey" checked={state[el.id]||false}
                  on_change={v=>set_state(s=>({...s, [el.id]: v, error: ''}))}
                />)}
              </div>
            </div>
            <Input_row label="Anything else you'd like us to know?"
              value={state.explain}
              on_change={value=>set_state(v=>({...v, explain: value}))}/>
            <Input_row label="Enter your email to help our support team"
              value={state.contact}
              on_change={value=>set_state(v=>({...v, contact: value}))}/>
            <Button caption="Submit" on_click={()=>send()}
              disabled={!is_button_active} color="black2023"/>
          </div>
        </div>
      </div>
    </div>;
};

export {Uninstall_survey_hola2023};
